export enum InputSizeTypes {
    sm = 'sm',
    md = 'md',
    lg = 'lg',
}

export enum InputLabelPositionTypes {
    top = 'top',
    left = 'left',
}

export enum InputValidationStateTypes {
    error = 'error',
    okay = 'okay',
}

export enum SelectGroupDirectionTypes {
    row = 'row',
    col = 'col',
}
